import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Body, Title } from '@vds/typography';
import { Button } from '@vds/buttons';
import { Col, Row } from '../../../../../common/Grid';
import AddonTile from './addonTile';
import AddonCarousel from './addonsCarousel';
import { getSession, isMobile, isWHWP2 } from '../../../../../common/Helpers';
import { getAddonData } from './addonsCommon';
import CommonModal from '../../../../../common/Modal';
import { eventDispatcher } from '../../../../../common/Tagging';

const WhwServices = (props) => {
  const [showDetailsModalWhw, setShowDetailsModalWhw] = useState(false);
  const [whwAddonModalData, setWhwAddonModalData] = useState({});

  const { refData, accessory = [] } = props;
  if (!refData?.length) {
    return null;
  }

  const prepareTileData = (service) => {
    if (!service || !service.skuDetails) {
      return {};
    }
    const { skuDetails, type, recurringInd, pricePlanId } = service;
    const tileData = getAddonData(service, refData);
    const removeAddon = () => props.removeAddon(skuDetails, tileData.title, type, recurringInd, pricePlanId);
    const addAddon = () => props.addAddon(props.notifyMessage, accessory, type, tileData.title, skuDetails);
    return {
      ...props,
      ...tileData,
      addAddon,
      removeAddon,
      detailsLinkListener: () => {
        setWhwAddonModalData(tileData);
        setShowDetailsModalWhw(true);
      },
    };
  };

  const tileDataWhw = accessory?.map((service) => prepareTileData(service));
  const getModalBodyWHW = (bodyContentwhw = []) =>
    bodyContentwhw?.map(({ subheader, description, note }) => (
      <>
        {subheader && <Title bold>{subheader}</Title>}
        {description && (
          <>
            <Title size="small" primitive="p">
              {description}
            </Title>
            {!note && <br />}
          </>
        )}
        {note && (
          <>
            <Body size="small" color="#6F7171">
              {note}
            </Body>{' '}
            <br />
          </>
        )}
      </>
    ));
  const getModalFooterWhw = () => (
    <Button
      size="large"
      use="primary"
      data-track={`{"type": "link", "name": "close","data":{"page":{"detail":"Review details | ${whwAddonModalData.detailModalHeader} modal" }}}`}
      onClick={() => {
        setShowDetailsModalWhw(false);
        setWhwAddonModalData({});
      }}
    >
      Close
    </Button>
  );
  return (
    <>
      {isMobile() && accessory?.length > 1 ? (
        <AddonCarousel data={tileDataWhw} renderItem={(carouselProps) => <AddonTile {...carouselProps} />} />
      ) : (
        <Row>
          {accessory?.map((serviceWHW) => (
            <Col key={serviceWHW?.prodId} colSizes={{ mobile: 4, tablet: 6, desktop: 6 }}>
              <AddonTile {...prepareTileData(serviceWHW)} />
            </Col>
          ))}
        </Row>
      )}
      {showDetailsModalWhw && whwAddonModalData && (
        <CommonModal
          id="whwReviewDetailsModal"
          ariaLabel={isWHWP2() && 'close'}
          opened={showDetailsModalWhw}
          dataTrack={`{"type": "link", "name": "close","data":{"page":{"detail":"Review details | ${whwAddonModalData.detailModalHeader} modal" }}}`}
          onOpenedChange={(newState) => {
            if (!newState) {
              setShowDetailsModalWhw(false);
              eventDispatcher('linkClick', {
                type: 'link',
                name: `close`,
                data: { page: { detail: `Review details | ${whwAddonModalData.detailModalHeader} modal` } },
              });
            }
            if (newState) {
              eventDispatcher('openView', {
                name: `Review details | ${whwAddonModalData.detailModalHeader} modal`,
                selector: `Review details | ${whwAddonModalData.detailModalHeader} modal`,
              });
            }
          }}
          modalTitle={whwAddonModalData.detailModalHeader}
          modalBody={
            whwAddonModalData?.detailModalBody
              ? getModalBodyWHW(whwAddonModalData?.detailModalBody)
              : getSession('FlowType') === '5G'
                ? getModalBodyWHW(whwAddonModalData?.detailModalBody5G)
                : getModalBodyWHW(whwAddonModalData?.detailModalBodyLTE)
          }
          modalFooter={getModalFooterWhw()}
        />
      )}
    </>
  );
};

WhwServices.propTypes = {
  refData: PropTypes.array.isRequired,
  accessory: PropTypes.array.isRequired,
  removeAddon: PropTypes.func.isRequired,
  services: PropTypes.array.isRequired,
  addAddon: PropTypes.func.isRequired,
  notifyMessage: PropTypes.string.isRequired,
  parentProps: PropTypes.object,
  whwTileData: PropTypes.array,
};

export default WhwServices;
